import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

/**
 * Initializes the looping ticker carousel when present.
 */
const Ticker = () => {
    const getSlidesPerView = () => {
        if (window.innerWidth >= 1200) {
            return 6;
        }

        return 4;
    };

    const updateScrollableClass = (carousel, wrapper) => {
        const originalSlideCount = carousel.querySelectorAll('.ticker__slide').length;
        const hasScrollableSlides = originalSlideCount > getSlidesPerView();

        carousel.classList.toggle('ticker__carousel--insufficient-slides', !hasScrollableSlides);

        if (wrapper) {
            wrapper.classList.toggle('ticker__carousel__wrapper--insufficient-slides', !hasScrollableSlides);
        }

        return hasScrollableSlides;
    };

    const init = () => {
        const carousels = document.querySelectorAll('.ticker__carousel.swiper');
        if (!carousels.length) return;

        const mq = window.matchMedia('(min-width: 992px)');

        carousels.forEach((carousel) => {
            let swiper = null;
            const wrapper = carousel.closest('.ticker__carousel__wrapper');

            const enable = () => {
                if (swiper) return;

                updateScrollableClass(carousel, wrapper);

                if (wrapper) {
                    wrapper.classList.add('ticker__carousel__wrapper--ticker');
                }
                swiper = new Swiper(carousel, {
                    modules: [Autoplay],
                    freeMode: true,
                    loop: true,
                    slidesPerView: 4,
                    speed: 5000,
                    spaceBetween: 40,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false,
                    },
                    allowTouchMove: false,
                    breakpoints: {
                        1200: {
                            slidesPerView: 6,
                            spaceBetween: 20
                        },
                    },
                });
            };

            const disable = () => {
                if (!swiper) return;
                swiper.destroy(true, true);
                swiper = null;
                if (wrapper) {
                    wrapper.classList.remove('ticker__carousel__wrapper--ticker');
                }
            };

            const handleChange = () => {
                if (mq.matches) {
                    enable();
                } else {
                    disable();
                    updateScrollableClass(carousel, wrapper);
                }
            };

            handleChange();

            if (mq.addEventListener) {
                mq.addEventListener('change', handleChange);
            } else {
                mq.addListener(handleChange);
            }
        });
    };

    return {
        init
    };
}

export default Ticker;
